import * as React from "react"
import { Row, Col, Popup } from "tdesign-react"

import { Layout, Seo } from "@/components"
import ProductBanner from "@/components/product/banner"
import PartnerIntroduce from "@/components/partner/partner-introduce"
import PartnerRights from "@/components/education-partner/partner-rights"
import CooperationFlow from "@/components/education/cooperation-flow"
import BecomePartner from "@/components/partner/become-partner"
import t from "@/constants/wording"

import * as styles from './index.module.scss'
import sandataeduImage from './sandataedu.png'
import oldboyeduImage from './oldboyedu.png'
import trsImage from './trs.png'
import togogoImage from './togogo.png'
import OutLink from "@/components/OutLink"

interface IProps {
  location: ILocation
}

const title = '教育合作伙伴'
const description = '面向服务高校、企业和个人的独立教育培训机构，通过原厂课程授权、联合师资培养、联合课程开发、授权培训和认证服务等构建高效的 PingCAP 培训认证服务体系，推动 PingCAP 旗下 TiDB & TiDB Cloud 相关人才生态的繁荣发展。'
export const PARTNER_RIGHTS: PartnerRights = {
  title: "合作伙伴权益",
  data: [
    {
      icon: "sale",
      name: "官方合作伙伴授权",
      describe: "获得官方合作伙伴权威认证",
    },
    {
      icon: "product",
      name: "培训交付和认证考试服务",
      describe: "包括原厂课程转售或咨询服务，联合开发课程培训服务，PingCAP 认证考试服务",
    },
    {
      icon: "marketing",
      name: "构建未来",
      describe: "赋能合作伙伴，共同打造更完善的 TiDB 人才生态",
    },
    // {
    //   icon: "emoji",
    //   name: "深度赋能",
    //   describe: "丰富培养计划和认证实现全方位赋能",
    // },
  ],
}
export const COOPERATION_FLOW = {
  className: "greyBg",
  title: "PingCAP 教育合作伙伴注册流程",
  flow: [
    {
      describe: "注册申请：申请加入 PingCAP 教育合作伙伴",
      list: [
        '了解成为 PingCAP 教育合作伙伴的要求和权益',
        '提交申请成为 PingCAP 授权教育合作伙伴',
        '解锁 TiDB 学习材料',
      ],
    },
    {
      describe: "合作对接：业务调研、制定合作计划，签署合作协议",
      list: [
        '合作伙伴业务调研 ',
        '合作对接',
        '制定合作计划 ',
        '合作试运行',
        '签订培训合作协议',
      ],
    },
    {
      describe: "伙伴认证：完成技术能力认证",
      list: [
        '按照合作伙伴级别要求参与讲师认证计划，并且完成讲师认证 ',
        '完成讲师认证，培训课件、讲义、实验手册等教学材料发送',
      ],
    },
    {
      describe: "通过认证，颁发授权书，开展教育培训业务",
      list: [
        '通过认证',
        '颁发 PingCAP 授权合作证书 ',
        '展开教育培训业务',
      ],
    },
  ],
}

const PARTNERS = [
  {
    url: 'http://ke.sandata.com.cn',
    image: sandataeduImage,
    description: (
      <>
        <p>晟数学苑是晟数科技旗下培训品牌，专注于大数据技术人才培养，课程为企业用户和技术从业者量身打造，采用理论与实战结合的教学方式，运用晟数科技云平台还原真实生产环境，本着提高客户终身竞争力为目标，全面提升企业综合水平和从业者的技术实力。企业定制培训更是结合企业现存实质问题，给出针对性的一体化解决方案。晟数学苑历经多年的发展，取得了行业客户的充分肯定。目前晟数学苑拥有以崔旭老师为代表的 TiDB 认证讲师两名，已经为广大学员提供多次 TiDB 标准课程培训。</p>
        <p>崔旭：晟数科技创始⼈，晟数学苑院长，TiDB 认证讲师，Oracle ACE，中国 OCM 之家（OCMH）创始人，中国 PostgreSQL 分会专家委员会副主委。拥有 Oracle 10g 11g 12c OCM 认证，同时获得 Oracle、MySQL、PostgreSQL、OceanBase、TiDB、达梦、SQL Server、RHCE、F5、Cisco 等十余种相关技术认证。</p>
      </>
    ),
  },
  {
    url: 'https://www.oldboyedu.com',
    image: oldboyeduImage,
    description: (
      <>
        <p>老男孩教育自成立以来，就一直专注于互联网 IT 技术人才培训、企业内训以及软件开发服务，先后开设了 Linux 运维、Python、网络安全、MySQL DBA 等学科。老男孩教育 MySQL DBA 专家班已开设多年，该课程由互联网一线大厂大咖名师亲自授课，可轻松助力学员进大厂。为了提高学员就业竞争优势，老男孩教育率先引入 TiDB 课程，并与 TiDB 厂商 — PingCAP 公司达成深度合作，双方充分发挥自身优势，共同研发出通俗易懂且具有实战性的 TiDB 认证课程，学完可考取 PingCAP PCTA、PCTP 原厂认证，还可获得 TiDB 生态企业高薪就业直推机会。</p>
        <p>目前，老男孩教育多位讲师已率先完成 PingCAP 讲师认证，未来双方将不定期共同举办直播活动，进行技术传播和布道。</p>
      </>
    ),
  },
  {
    //url: '#',
    image: trsImage,
    description: (
      <>
        <p>南京拓尔思智能系统有限公司作为拓尔思信息技术有限公司的控股子公司，专注于海量非结构化与结构化信息处理为核心的软件研发和技术支持，面向政务、金融、媒体、公共服务等行业的专业服务场景提供服务。</p>
        <p>南京拓尔思智能业务包括基于数据中台、AI 分析平台、BI 分析平台、大屏可视化工具等大数据及人工智能相关产品研发；基于语义智能的元宇宙数字人相关技术研发；基于高校数字化人才培养、企业数字化人才培养、大数据产品服务人才配套和数字人才库等的数字人才服务板块，目前已经和 PingCAP 就 TiDB 人才培养签署合作。</p>
      </>
    ),
  },
  {
    url: 'http://www.togogo.net/',
    image: togogoImage,
    description: (
      <>
        <p>腾科 IT 教育是一家聚焦 IT 教育和 IT 人才，提供面授/在线培训与教育、IT 人才培养与新工科建设（高校专业共建与实验室建设等）、企业人才定制培养等解决方案的专业公司。总部位于广州，下辖广州腾科网络技术有限公司、广州市腾科职业培训学校、广州腾科网络技术有限公司深圳分公司、广州猎卓人力资源服务有限公司、博睿（广州）科技有限公司，以及 30 多个培训网点， 业务涵盖全国主要大、中型城市。腾科 IT 教育是 PingCAP、华为（Huawei）、红帽（Red Hat）、360 数字安全集团、甲骨文（Oracle）、亚马逊云（AWS)、中国开源软件推进联盟 PostgreSQL 分会（PostgreSQL）、美国计算机行业协会（CompTIA）、阿里云、安恒、商汤科技等十余家国际知名 IT 技术厂商和组织的授权培训（学习）合作伙伴，是广东省计算机学会常务理事单位。在数据库领域有多年的培训经验，有完善的培训体系，致力于培养专业的IT技术人才。</p>
      </>
    ),
  },
]

const EducationPartner: React.FC<IProps> = ({ location }) => {
  // const data = useStaticQuery<SolutionPartnerQuery>(graphql`
  //   query StrapiSolutionPartnerQuery {
  //     allStrapiLogoWallForSolutionPartners(
  //       limit: 6
  //       sort: { fields: order, order: ASC }
  //     ) {
  //       nodes {
  //         id
  //         logo {
  //           alt
  //           media {
  //             url
  //           }
  //         }
  //       }
  //     }
  //   }
  // `)
  //
  // const logoWallData = data.allStrapiLogoWallForSolutionPartners.nodes || []

  return (
    <div className="solution-partner">
      <Layout>
        <Seo
          title={title}
          description={description}
          keywords={t("keywords")}
        />
        <ProductBanner className="partnerBanner" text={title} />
        <PartnerIntroduce text={description} />
        <PartnerRights content={PARTNER_RIGHTS} />
        <CooperationFlow cooperationFlow={COOPERATION_FLOW} />
        {/*<PartnerLogoWall data={logoWallData} />*/}
        <div className={styles.partner}>
          {/*<h2>合作伙伴</h2>*/}
          <Row gutter={[64, 64]} justify={'center'} align={'middle'}>
            {PARTNERS.map((value) => (
              <Col xs={12} sm={6} md={4} lg={2} xl={2} style={{textAlign: 'center'}}>
                {/*<div style={{textAlign: 'center', margin: '0 auto'}}>*/}
                  <OutLink href={value.url}>
                    <Popup
                      //visible={true}
                      //overlaySt yle={{borderColor: '#051853'}}
                      showArrow={false}
                      overlayInnerStyle={{backgroundColor: '#051853', boxShadow: 'none', color: '#FFF', maxWidth: 540}}
                      placement="bottom"
                      content={(
                        <>
                          <div className={styles.description}>
                            {value.description}
                          </div>
                          {(value.url !== "#" && value.url !== "") && (
                            <p>
                              <OutLink href={value.url} style={{ color: "#FFF" }}>{value.url}</OutLink>
                            </p>
                          )}
                        </>
                      )}
                    >
                      <img src={value.image} alt={''} style={{width: 176}} />
                    </Popup>
                  </OutLink>
                {/*</div>*/}
              </Col>
            ))}
          </Row>
        </div>
        <BecomePartner text={{ title: '成为 PingCAP 教育合作伙伴' }} location={location} />
      </Layout>
    </div>
  )
}

export default EducationPartner
